export default {
    title: 'Reset your password',
    title_submitted: 'Done! Login to continue.',
    title_expired: 'Request expired',
    subtitle: 'Please enter your new password.',
    buttons: {
        go_to_login: 'Go to login',
    },
    notifications: {
        password_changed: 'Your password has been changed',
        request_expired: 'Your request has been expired. Please try again!',
    },
}
